import { render, staticRenderFns } from "./BacEventFormFinishView.vue?vue&type=template&id=6baff11d&scoped=true&"
import script from "./BacEventFormFinishView.vue?vue&type=script&lang=ts&"
export * from "./BacEventFormFinishView.vue?vue&type=script&lang=ts&"
import style0 from "./BacEventFormFinishView.vue?vue&type=style&index=0&id=6baff11d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baff11d",
  null
  
)

export default component.exports